import { IsString, IsArray, IsBoolean, IsInt, MaxLength, ArrayMaxSize } from "class-validator";
import { Type } from "class-transformer";

export class AbcCharactersCheckQueryDto {
	@Type(() => String)
	@ArrayMaxSize(100)
	@IsArray()
	@IsString({each: true})
	c: string[] = [];
}

export class AbcCharactersCheckResultDto {
	@IsBoolean()
	exists: boolean;

	@IsInt()
	strokesCount?: number;
}

